import { render, staticRenderFns } from "./LoginLeftColumn.vue?vue&type=template&id=4d9abb0b"
import script from "./LoginLeftColumn.vue?vue&type=script&lang=js"
export * from "./LoginLeftColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports